export default Object.freeze({
  TITLE: '아이콘 관리',
  NO_DATA: '등록된 스티거가 없습니다.',
  GUIDE1: '등록된 아이콘은 상품등록 시, 선택할 수 있습니다.',
  GUIDE2: '쇼핑몰 프론트 정책에 따라 아이콘이 노출됩니다.',
  GUIDE3: '아이콘은 등록된 순서에 따라 노출됩니다. (상단에 등록된 아이콘 우선 노출)',
  BUTTON_DELETE: '선택 삭제',
  BUTTON_ADD: '아이콘 등록',
  SAVE: '변경사항 저장',
  CONFIRM1: '상품에 등록된 아이콘이 삭제됩니다. 삭제하시겠습니까?',
  HEADER_MODIFY: '수정',
  HEADER_TYPE: '형식',
  HEADER_CONTENT: '내용',
  HEADER_PRODUCT: '적용상품',
  HEADER_DELETE: '삭제',
  HEADER_ORDER: '순서',
  VIEW: '보기',
  IMAGE: '이미지',
  TEXT: '텍스트',
  TITLE_UPDATE: '아이콘 수정',
  TITLE_ADD: '아이콘 등록',
  GUIDE4: '이미지 등록 가이드',
  GUIDE5: '파일용량 10kb 미만',
  GUIDE6: '파일형식 jpg, jpeg, gif, png, bmp',
  PLACEHOLDER: '내용을 입력해주세요.',
  IMAGE_UPLOAD: '이미지 업로드',
  ALERT: '등록 실패하였습니다.\r\n최대 10KB까지 가능합니다.',
  ALERT_SAVE: '아이콘이 저장되었습니다.',
  ALERT1: '아이콘을 선택해주세요',
  ALERT2: '내용을 입력해주세요.',
  ALERT3: '이미지파일(Jpg,jpge,gif,png,bmp)만 등록해주세요.',
  CONFIRM: '상품에 등록된 아이콘이 수정됩니다. 수정하시겠습니까?',
  USE_PRODUCT: '적용상품',
  SEARCH_RESULT: '조회 결과',
  MALL: '쇼핑몰',
  PRODUCT_NO: '상품번호',
  PRODUCT_NAME: '상품명',
  RPODUCT_MANAGE_CD: '상품관리코드',
  PRODUCT_BRAND: '브랜드',
  PRODUCT_SALE_METHOD_TYPE: '판매방식',
  PRODUCT_SALE_METHOD_TYPE_PURCHASE: '사입',
  PRODUCT_SALE_METHOD_TYPE_CONSIGNMENT: '위탁',
  PRODUCT_PARTNER: '파트너사',
  PRODUCT_ADMIN: '담당자',
  PRODUCT_APPLY_STATUS_TYPE: '승인상태',
  PRODUCT_SALE_STATUS_TYPE: '판매상태',
  PRODUCT_DISPLABLE: '전시상태',
  PRODUCT_DISPLABLE_Y: '전시가능',
  PRODUCT_DISPLABLE_N: '전시불가',
  PRODUCT_FRONT_DISPLAY_N: '프론트 미노출',
  PRODUCT_FRONT_DISPLAY_Y: '프론트 노출',
  PRODUCT_SET: '세트',
  REGISTRATION_READY: '등록대기',
  APPROVAL_READY: '승인대기',
  APPROVAL_REJECTION: '승인거부',
  SALE_AGREEMENT_READY: '판매합의대기',
  SALE_AGREEMENT_REJECTION: '판매합의거부',
  FINISHED: '승인완료',
  AFTER_APPROVAL_READY: '수정 후 승인대기',
  AFTER_APPROVAL_REJECTION: '수정 후 승인거부',
  PRE_APPROVAL_STATUS: '승인완료이전',
  WAITING_PRE_SALE: '예약판매대기',
  ON_PRE_SALE: '예약판매중',
  WAITING_SALE: '판매대기',
  ON_SALE: '판매중',
  END_SALE: '판매종료',
  AVAILABLE_FOR_SALE: '판매가능',
  STOP_SELLING: '판매중지',
  PROHIBITION_SALE: '판매금지',
  ADD: '아이콘 등록',
  UPDATE: '아이콘 수정',
  SAVED: '저장되었습니다.',
  ERROR_PRODUCTNO: '상품번호가 정확하지 않습니다.\n새로고침 후 다시 시도해주세요.',
});
